import React from "react";
import { Link } from "react-router";
import { Container, Header, List } from "semantic-ui-react";
import { ELK_MONITORING_CONFIG, toUrl } from "config/elk-monitoring-config";

function ElkMonitoring() {
  const config = ELK_MONITORING_CONFIG[process.env.REACT_APP_ENVIRONMENT_NAME];
  return (
    <Container fluid>
      <Header as="h2" textAlign="center">
        ELK Monitoring
      </Header>
      <Header dividing>Introduction</Header>
      Comprehensive information about dashboards and alerts configured in ELK for API Gateway REST and Websocket
      endpoints. <br />
      All items are configured in EEM space thus users having access to EEM space will only be able to open the links.
      {config?.items.map((category) => (
        <React.Fragment key={category.name}>
          <Header dividing>{category.title}</Header>
          {category.description}
          <List as="ul">
            {category.items.map((item) => (
              <React.Fragment key={item.name}>
                <List.Item as="li">
                  <b>
                    <Link to={toUrl(config.space, category.prefix, item.id) } target="_blank">
                      {item.name}
                    </Link>
                  </b>
                  <br/>{item.description}
                </List.Item>
                <br/>
              </React.Fragment>
            ))}
          </List>
        </React.Fragment>
      ))}
    </Container>
  );
}

export default ElkMonitoring;
